/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CittadinoServizioMensaConfigurazioneDTO { 
    servizio_id?: string;
    data_inizio?: string;
    data_fine?: string;
    tipo_pagamento?: CittadinoServizioMensaConfigurazioneDTOTipoPagamentoEnum;
    gestione_manuale?: boolean;
    generazione_ricariche_abilitata?: boolean;
    orario_massimo_per_annullamento_pasto?: string;
    assistenza_email?: string;
}
export enum CittadinoServizioMensaConfigurazioneDTOTipoPagamentoEnum {
    NON_GESTITO = 'NON_GESTITO',
    MANUALE = 'MANUALE',
    PAGO_PA_RICARICHE = 'PAGO_PA_RICARICHE',
    PAGO_PA_RENDICONTAZIONE_E_RICARICHE = 'PAGO_PA_RENDICONTAZIONE_E_RICARICHE',
    PAGO_PA_RENDICONTAZIONE = 'PAGO_PA_RENDICONTAZIONE'
};



